export const playBannerEnglish = {
  PLAY_BANNER_TITLE: "SELISE Club for Android",
  PLAY_BANNER_HINT: "Get the app on Google Play for a faster experience.",
  PLAY_BANNER_CTA: "Get it",
  PLAY_BANNER_DISMISS: "Dismiss",
};

export const playBannerGerman = {
  PLAY_BANNER_TITLE: "SELISE Club für Android",
  PLAY_BANNER_HINT: "Hol dir die App bei Google Play für ein schnelleres Erlebnis.",
  PLAY_BANNER_CTA: "Holen",
  PLAY_BANNER_DISMISS: "Schliessen",
};
